import { Component, OnInit } from '@angular/core';
import {NbDialogRef} from "@nebular/theme";

@Component({
    selector: 'ngx-create-address-info',
    templateUrl: './create-address-info.component.html',
    styleUrls: ['./create-address-info.component.scss'],
})
export class CreateAddressInfoComponent implements OnInit {

    constructor(
        protected dialogRef: NbDialogRef<any>
    ) { }

    // tslint:disable-next-line:no-empty
    ngOnInit(): void {
    }

    public close(): void{

        this.dialogRef.close();
    }

}
